import { Injectable } from '@angular/core';
import { VssUiConfig } from "../vss-ui.model";
import { VssApiService } from './vss-api.service';

@Injectable({ providedIn: 'root'})
export class VssAdminService {
  url ='';
  urlBase = ''
  constructor(
    private apiServices: VssApiService,
    private vssUiConfig: VssUiConfig
  ) {
    this.urlBase =`${this.vssUiConfig.urlAdmin!}${this.vssUiConfig.contextPathBase!}`
    this.url = `${this.vssUiConfig.urlAdmin!}${this.vssUiConfig.contextPathBase!}/app-config`;

  }

  getConfigParam(params: any) {
    return this.apiServices.getBase(`${this.url}/get-by-config-code`, params);
  }
  createConfig(params: any) {
    return this.apiServices.postBase(`${this.url}/create`, params);
  }
  updateConfig(params: any) {
    return this.apiServices.postBase(`${this.url}/update`, params);
  }
  searchConfigList(params: any) {
    return this.apiServices.postBase(`${this.url}/search`, params);
  }
  addData(params: any) {
    return this.apiServices.postBase(`${this.url}/save`, params);
  }
  deleteConfig(params: any) {
    return this.apiServices.postBase(`${this.url}/deleteByIds`, params);
  }
  findDataByIds(params: any) {
    return this.apiServices.postBase(`${this.url}/findByIds`, params);
  }

  getTableColumn(url: string, params: any) {
    return this.apiServices.getBase(this.urlBase + url,  params);
  }

  saveColumnTable(url: string, body: any){
    // return this.http.post(`${this.testUrl}${url}?tableName=${body.tableName}&value=${body.value}`, "");
    return this.apiServices.postBase(`${this.urlBase + url}?tableName=${body.tableName}&value=${body.value}`, null);
  }

  getDetailTable(url: string, params: any) {
    // return this.http.get(`${this.testUrl}/api/v1/admin/table-detail/get-all-detail`, { params: params});
    return this.apiServices.getBase(this.urlBase + url,  params);
  }
}
